import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedSubtypeView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'sub_type'
  alias: 'Source Type'
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeSubtype(value)

  getDescription: (value) ->
    if value == "gp_review_comment"
      return "Google Play review comment"
    return value
